import { NgModule, inject } from '@angular/core';
import {
  PreloadAllModules,
  Router,
  RouterModule,
  Routes,
} from '@angular/router';
import { AuthenticationFirebaseService } from './shared';

// Functionnal guard
export const authGuard = async () => {
  const router = inject(Router);
  const authService = inject(AuthenticationFirebaseService);
  const user = await authService.getUser();
  if (user) {
    return true;
  } else {
    router.navigate(['/authentication'], { replaceUrl: true });
    return false;
  }
};

const routes: Routes = [
  {
    path: 'authentication',
    loadChildren: () =>
      import('./authentication/authentication.module').then(
        (am) => am.AuthenticationModule
      ),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((dm) => dm.DashboardModule),
    canActivate: [authGuard],
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
